<div class="maintenance-page">
  <div class="maintenance-content">
    <img [src]="'logos/logo-secondary.svg' | contentAssetImage" alt="" class="logo" />
    <div class="maintenance-card">
      <div class="icon material-symbols-outlined maintenance-icon">engineering</div>
      <h5 class="maintenance-title">{{ 'maintenance.page.text' | translate }}</h5>
      <p class="maintenance-description" [innerHTML]="'maintenance.page.description' | translate | markdownTranslate"></p>
    </div>
  </div>
</div>
